import React, { useEffect, useRef, useState } from "react";

import styles from "./OrderModal.module.scss";

import axios from "axios";

import useScreenSize from "../../hooks/useScreenSize";
import useUsers from "../../hooks/useUsers";

export default function OrderModal(props) {
  const { handleInterested, id = "", productName = "" } = props;

  const { interestedProduct } = useUsers();

  const [hasSent, setSent] = useState(false);

  const [bitrixPayload, setBitrixPayload] = useState({
    name: "",
    surname: "",
    phone: "+994", // Default olaraq +994 prefiksi ilə başlayır
    region: "",
  });

  const handleChangePayload = (e) => {
    const { name, value } = e.target;
    let val;

    if (name === "phone") {
      // Telefon nömrəsi üçün +994 prefiksini qoruyuruq
      if (!value.startsWith("+994")) {
        val = "+994" + value.replace(/[^0-9]/g, ""); // Yalnız rəqəmlər qalır
      } else {
        val = value.replace(/[^0-9+]/g, ""); // + və rəqəmlər qalır
      }

      // Maksimum uzunluğu 13 simvol ilə məhdudlaşdırırıq
      if (val.length > 13) {
        val = val.slice(0, 13);
      }
    } else {
      // Ad, soyad və rayon sahələri üçün
      val = value?.replace(/[^a-zA-ZƏəÇçĞğİıÖöŞşÜü\s]/g, '');
    }

    setBitrixPayload({ ...bitrixPayload, [name]: val });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const closeModalRef = useRef(null);

  const { isMobile } = useScreenSize();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
          closeModalRef.current &&
          !closeModalRef.current.contains(event.target)
      ) {
        handleInterested(event);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeModalRef, handleInterested]);

  const device = isMobile ? "UC_ERXCT6" : "PARTNER";

  const handleReguestToBitrix = async () => {
    const bitrixUrl = `https://bitrix24.digitup.az/rest/1/ag0y75jn3v4zqp3o/crm.lead.add.json?FIELDS[NAME]=${bitrixPayload.name}&FIELDS[TITLE]=Texnika alışı ${productName} ${bitrixPayload.name} ${bitrixPayload.surname} ${bitrixPayload.phone} &FIELDS[LAST_NAME]=${bitrixPayload.surname}&FIELDS[STATUS_ID]=NEW&FIELDS[ASSIGNED_BY_ID]=1&FIELDS[CURRENCY_ID]=AZN&FIELDS[PHONE][0][VALUE]=${bitrixPayload.phone}&FIELDS[PHONE][0][VALUE_TYPE]=WORK&FIELDS[SOURCE_ID]=${device}&FIELDS[UF_CRM_1683203862974]=${bitrixPayload.region}&FIELDS[UF_CRM_1683204119757]=27&FIELDS[UF_CRM_1683203993792]=${productName}&FIELDS[UF_CRM_1683204020860]=${id}`;

    try {
      const response = await axios.get(bitrixUrl);

      if (response.status === 200) {
        setSent(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleReguestToServer = async (productId) => {
    const { name, surname, phone, region } = bitrixPayload;

    try {
      const response = await interestedProduct(
          name,
          surname,
          phone,
          region,
          productId
      );

      if (response.data) {
        setSent(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSend = () => {
    if (!bitrixPayload.phone) return;

    const productId = id;
    handleReguestToBitrix();

    handleReguestToServer(productId);
  };

  return (
      <div className={styles.container}>
        {hasSent ? (
            <div className={styles.closeModal} ref={closeModalRef}>
              <h1>Təşəkkür edirik!</h1>
              <p>Tezliklə sizə zəng edəcəyik.</p>
              <button onClick={handleInterested} className="mainBtn">
                oldu
              </button>
            </div>
        ) : (
            <div className={styles.modalContainer}>
              <h1>Sorğu göndərmək üçün xanaları doldurun</h1>
              <form ref={closeModalRef} onSubmit={handleSubmit}>
                <label htmlFor="name">Ad</label>
                <input
                    autoComplete="off"
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Ad"
                    maxLength={20}
                    pattern="[A-Za-z0-9ƏəÇçĞğİıÖöŞşÜü]+"
                    value={bitrixPayload.name}
                    onChange={handleChangePayload}
                />
                <label htmlFor="surname">Soyad</label>
                <input
                    autoComplete="off"
                    id="surname"
                    name="surname"
                    maxLength={20}
                    type="text"
                    pattern="[A-Za-z0-9ƏəÇçĞğİıÖöŞşÜü]+"
                    placeholder="Soyad"
                    value={bitrixPayload.surname}
                    onChange={handleChangePayload}
                />
                <label htmlFor="region">Rayon</label>
                <input
                    autoComplete="off"
                    id="region"
                    name="region"
                    maxLength={20}
                    type="text"
                    pattern="[A-Za-z0-9ƏəÇçĞğİıÖöŞşÜü]+"
                    placeholder="Rayon"
                    value={bitrixPayload.region}
                    onChange={handleChangePayload}
                />
                <label aria-required htmlFor="phone">
                  Telefon
                </label>
                <input
                    autoComplete="off"
                    required
                    id="phone"
                    name="phone"
                    type="tel"
                    maxLength={13}
                    placeholder="051 000 00 00"
                    value={bitrixPayload.phone}
                    onChange={handleChangePayload}
                />

                <button className="mainBtn" type="submit" onClick={handleSend}>
                  Göndər
                </button>
              </form>
            </div>
        )}
      </div>
  );
}
